var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBathTowels = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#222830",
  d: "M23.22 3.91h-1.33v-.42c0-1.6-1.24-2.91-2.81-3.05V.41H5.82C3.82.42 2.2 1.84 2.2 3.59v.33H.77a.734.734 0 0 0-.75.74c0 .41.34.75.75.75H2.2v17.54c0 .41.34.75.75.75h13.63c.41 0 .75-.34.75-.75v-3h3.81c.41 0 .75-.34.75-.75V5.41h1.33c.41 0 .75-.34.75-.75s-.34-.75-.75-.75m-2.83-.42v.42H17.5c-.07 0-.13.02-.2.04v-.53c0-.83.67-1.5 1.5-1.5.87 0 1.58.71 1.58 1.58zM3.7 22.2V3.59c0-.92.95-1.67 2.12-1.67h10.41c-.26.44-.42.95-.42 1.5V19.2s.02.07.02.11v2.88H3.7zm16.69-3.75h-3.08V5.37c.06.02.13.04.2.04h2.89v13.04z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgBathTowels;